import React, { useState, useEffect, useRef } from 'react';
import { ChevronRight, ChevronDown, X, Navigation } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';


const redIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
  iconRetinaUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
  shadowUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const cowrks = {
  Bengaluru: {
    "Centennial C‑Block": {
      address: "5th Floor, C-Block, Centennial EPIP Zone, Whitefield, Bangalore – 560066",
      lat: 12.9875, lng: 77.7289
    },
    "Campus D, Whitefield": {
      address: "Campus D, 7th Cross Rd, Whitefield, Brookfield, Bangalore – 560066",
      lat: 12.9878, lng: 77.7220
    },
    "Campus 3B, Bellandur": {
      address: "1st Floor, Campus 3B, Outer Ring Rd, Adarsh Palm Retreat, Bellandur, Bangalore – 560103",
      lat: 12.9355, lng: 77.6765
    },
    "Ecoworld Block 6A": {
      address: "Block 6A, Ecoworld, ORR, Devarabeesanahalli, Bangalore – 560103",
      lat: 12.9339, lng: 77.6853
    },
    "Ecoworld Tower 4D": {
      address: "Ecoworld, Tower 4D, Sarjapur Marthahalli ORR, Bangalore – 560103",
      lat: 12.9279, lng: 77.6779
    },
    "New Indiranagar": {
      address: "Tower B, Infinity, Old Madras Rd, Bennigana Halli, Bangalore – 560016",
      lat: 12.9891, lng: 77.6290
    },
    "Residency Road": {
      address: "No 135/1, Purva Premier, Residency Road, Bangalore – 560025",
      lat: 12.9719, lng: 77.5942
    },
    "EPIP Industrial Area": {
      address: "EPIP Industrial Area, Whitefield Road near SAP Labs, Bangalore – 560066",
      lat: 12.9875, lng: 77.7289
    },
    "Yelahanka Galleria": {
      address: "Galleria, Ambedkar Colony, Yelahanka, Bangalore – 560064",
      lat: 13.0987, lng: 77.5871
    }
  },
  Mumbai: {
    "Equinox Tower3 Ground Floor": {
      address: "Equinox Tower 3, Ground Floor, Kurla West, Mumbai – 400070",
      lat: 19.0815, lng: 72.8890
    },
    "Equinox Tower 3 6th Floor": {
      address: "Equinox Tower 3, 6th Floor, Kurla West, Mumbai – 400070",
      lat: 19.0815, lng: 72.8890
    },
    "Spectra Powai": {
      address: "Unit 401, Spectra, Powai, Mumbai – 400076",
      lat: 19.1165, lng: 72.9086
    },
    "Prudential IT Park": {
      address: "3rd Floor, Prudential IT Park, Powai, Mumbai – 400076",
      lat: 19.1244, lng: 72.8375
    },
    "Winchester Powai": {
      address: "Winchester, Powai, Mumbai – 400076",
      lat: 19.1162, lng: 72.9112
    },
    "Birla Centurion Worli": {
      address: "Birla Centurion, Worli, Mumbai – 400030",
      lat: 19.0123, lng: 72.8304
    }
  },
  Delhi: {
    "Aerocity Worldmark 1": {
      address: "Worldmark 1, Aerocity, Delhi – 110037",
      lat: 28.5511, lng: 77.1230
    },
    "Cyber City DLF Phase 2": {
      address: "DLF Cyber City Phase 2, Gurugram – 122002",
      lat: 28.4956, lng: 77.0904
    },
    "Paras Twin Tower": {
      address: "Paras Twin Tower, Sector 54, Gurgaon – 122011",
      lat: 28.4278, lng: 77.0956
    },
    "Sector 21 Gurugram": {
      address: "Sector 21, Gurugram – 122022",
      lat: 28.5164, lng: 77.0017
    },
    "Sector 135 Noida": {
      address: "Sector 135, Noida – 201304",
      lat: 28.5739, lng: 77.3764
    },
    "Sector 62 Noida": {
      address: "Sector 62, Noida – 201309",
      lat: 28.6328, lng: 77.3650
    },
    "Sector 48 Gurugram": {
      address: "Sector 48, Gurugram – 122022",
      lat: 28.4256, lng: 77.0291
    },
    "Atelier Suites Aerocity": {
      address: "Atelier Suites, Worldmark 3, Aerocity, New Delhi – 110037",
      lat: 28.5511, lng: 77.1230
    }
  },
  Chennai: {
    "Perungudi Campus3B Floor-6": {
      address: "Campus 3B, 6th Floor, Millenia 11, Perungudi, Chennai – 600096",
      lat: 12.9660, lng: 80.2414
    },
    "Perungudi Campus3B Floor-5": {
      address: "Campus 3B, 5th Floor, Millenia 11, Perungudi, Chennai – 600096",
      lat: 12.9660, lng: 80.2414
    },
    "Arihanth Technopolis": {
      address: "Arihanth Technopolis, Old Mahabalipuram Road, Perungudi, Chennai – 600096",
      lat: 12.9660, lng: 80.2415
    }
  },
  Pune: {
    "Baner 45ICON": {
      address: "45ICON, Baner Road, Pune 411045",
      lat: 18.5637, lng: 73.7764
    }
  },
  Hyderabad: {
    SandhyaTechno: {
      address: "No.# 610 /B, 6th floor, Sandhya Techno-1 X-road, Radhe Nagar, Khajaguda, Raidurgam, Hyderabad, Telangana - 500081",
      lat: 17.421897, lng: 78.384409
    },
    "THE SKYVIEW 10 ": {
      address: "1st & 2nd Floor, Skyview 10, Hitech City Main Road, Raidurgam, Hyderabad 500081, Telangana, India",
      lat: 17.43277, lng: 78.37527
    }
  },
  Vizag: {
    "APIS IT Incubation Centre": {
      address: "APIS, IT Incubation Centre, Hill No - 03 Sunrise, Road, Startup Village, Pedda Rushikonda, Madhurawada, Visakhapatnam, Andhra Pradesh 530045",
      lat: 17.6868,
      lng: 83.2185
    }
  }
};

export default function OurLocations() {
  const [city, setCity] = useState('Hyderabad');
  const [subl, setSubl] = useState('SandhyaTechno');
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);
  const [showFullMap, setShowFullMap] = useState(false);


  useEffect(() => {
    if (!cowrks[city]?.[subl]) {
      setCity('Hyderabad');
      setSubl('SandhyaTechno');
    }
  }, [city, subl]);

  const handleCity = c => {
    setCity(c);
    setSubl(Object.keys(cowrks[c])[0]);
  };
  const handleSub = s => {
    setSubl(s);
    setShowMenu(false);
  };

  const locationData = cowrks[city]?.[subl];
  const mapCenter = locationData ? [locationData.lat, locationData.lng] : [17.4474, 78.3762];

  return (
    <div className="bg-black text-white py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
      <Helmet>
        <title>Adithya Infinity</title>
      </Helmet>
      <style>{`
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
      <div className="max-w-4xl mx-auto text-left sm:text-center">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold mb-4 sm:mb-6 ">
          Our <span className="text-cyan-400">Locations</span>
        </h2>

        <div className="flex justify-start sm:justify-center mb-6 sm:mb-8 items-center ">
          <div className="relative z-[5000]" ref={menuRef}>
            <div
              onClick={() => setShowMenu(v => !v)}
              className="px-4 py-3 bg-white text-black rounded-lg cursor-pointer flex items-center gap-2 text-sm sm:text-base touch-manipulation"
            >
              <span className="truncate max-w-[140px] xs:max-w-[180px] sm:max-w-none">{subl}, {city}</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${showMenu ? 'rotate-180' : ''}`} />
            </div>
            {showMenu && (
              <div
              className="absolute left-0 sm:right-0 bg-white text-black mt-2 p-3 sm:p-4 rounded-lg shadow-2xl z-[9999] sm:w-[440px] w-[90vw] flex flex-col sm:flex-row gap-3"
              style={{ maxHeight: '500px', overflowY: 'auto' }}>

                <div className="min-w-[100px] sm:min-w-[120px] md:min-w-[140px] border-r pr-2 overflow-y-auto">
                  {Object.keys(cowrks).map(c => (
                    <div
                      key={c}
                      onMouseEnter={() => handleCity(c)}
                      onTouchStart={() => handleCity(c)}
                      className="flex justify-between items-center px-2 sm:px-3 py-2 hover:bg-gray-200 cursor-pointer text-sm sm:text-base touch-manipulation"
                    >
                      <span className="truncate">{c}</span>
                      <ChevronRight className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />
                    </div>
                  ))}
                </div>
                <div className="min-w-[120px] sm:min-w-[140px] md:min-w-[160px] pl-2 overflow-y-auto">
                  {cowrks[city] &&
                    Object.keys(cowrks[city]).map(s => (
                      <div
                        key={s}
                        onClick={() => handleSub(s)}
                        onTouchStart={() => handleSub(s)}
                        className={`px-2 sm:px-3 py-2 cursor-pointer hover:bg-gray-200 text-sm sm:text-base touch-manipulation ${
                          s === subl ? 'bg-gray-300 font-semibold' : ''
                        }`}
                      >
                        <span className="truncate">{s}</span>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        </div>

        {locationData && (
          <div className="bg-zinc-900 p-4 sm:p-6 rounded-lg mx-auto max-w-xl text-left">
            <div className="h-48 xs:h-56 sm:h-64 md:h-72 lg:h-80 xl:h-96 mb-4 relative">
              <MapContainer
                key={`${city}-${subl}`}
                center={mapCenter}
                zoom={16}
                scrollWheelZoom={true}
                style={{ width: '100%', height: '100%' }}
                className={showMenu ? 'pointer-events-none' : 'rounded'}
              >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <Marker position={mapCenter} icon={redIcon}>
                  <Popup>
                    {subl}, {city}
                    <br />
                    {locationData.address}
                  </Popup>
                </Marker>
              </MapContainer>
            </div>
            <div className="flex justify-between mb-4">
              <button
                className="text-xs px-4 py-2 bg-green-500 hover:bg-green-400 text-white rounded-lg transition-colors touch-manipulation flex items-center gap-2"
                onClick={() => {
                  const address = encodeURIComponent(locationData.address);
                  const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${address}`;
                  window.open(mapsUrl, '_blank');
                }}
              >
                <Navigation className="w-4 h-4" />
                Get Directions
              </button>
              <button
                className="text-xs px-4 py-2 bg-cyan-500 hover:bg-cyan-400 text-black rounded-lg transition-colors touch-manipulation"
                onClick={() => setShowFullMap(true)}
              >
                View larger map
              </button>
            </div>
            <h3 className="text-cyan-400 text-lg sm:text-xl font-bold mb-2">{subl}, {city}</h3>
            <p className="text-gray-300 text-sm sm:text-base">{locationData.address}</p>
            {/* <p className="text-cyan-200 mt-2 text-sm sm:text-base">📞 {locationData.phone}</p> */}
          </div>
        )}

        {showFullMap && (
          <div className="fixed inset-0 bg-black/90 z-[9999] flex items-center justify-center p-2 sm:p-4" onClick={() => setShowFullMap(false)}>
            <div className="bg-zinc-900 rounded-lg w-full h-full max-w-6xl max-h-[90vh] relative" onClick={e => e.stopPropagation()}>
              <button
                className="absolute top-3 right-3 bg-white text-black rounded-full p-3 sm:p-2 z-10 hover:bg-gray-200 transition-colors touch-manipulation"
                onClick={() => setShowFullMap(false)}
                aria-label="Close full-screen map"
              >
                <X className="w-5 h-5 sm:w-4 sm:h-4" />
              </button>
              <MapContainer
                key={`${city}-${subl}-full`}
                center={mapCenter}
                zoom={16}
                scrollWheelZoom={true}
                style={{ width: '100%', height: '100%' }}
                className="rounded-lg"
              >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <Marker position={mapCenter} icon={redIcon}>
                  <Popup>
                    {subl}, {city}
                    <br />
                    {locationData?.address}
                  </Popup>
                </Marker>
              </MapContainer>
            </div>
          </div>
        )}


      </div>
    </div>
  );
}
